<template>
  <li>
    <div class="car p-0 mb-3">
      <div class="mb-3">
        <span
          v-if="model.is_available && !model.available_from_is_passed"
          class="badge badge-green position-absolute mt-1 ml-1 r-0"
        >{{ i18n.app.text.direct_available }}</span>
        <span
          v-if="!model.available_from_is_passed"
          class="badge badge-orange position-absolute mt-1 ml-1 r-0"
        >
          {{ i18n.database.table.vehicles.columns.available_from }}
          <br />
          {{ model.available_from | datetime }}
        </span>

        <VehicleImage :model="model.main_image" :thumb="false" />
      </div>

      <div class="car__title pb-2 pl-0">
        <span
          class="car__title__segment"
          :style="model.segment && model.segment.color ? {
            'background-color': model.segment.color.hex,
            'color': model.segment.color.text_color + ' !important'
          } : null"
        >{{ model.segment && model.segment.name }}</span>
        <div class="car__title__model pl-0">{{ model.name }}</div>
      </div>

      <div class="pb-2 pl-0">
        <div
          class="license"
          :class="(model.country ? model.country.iso_3166_2 : 'nl') | lowercase"
        >{{ model.license_plate }}</div>
      </div>

      <div class="car__specs pl-0">
        <span v-if="model.fuel_type">{{model.fuel_type.name}}</span>
        <span v-if="model.transmission_type">
          , {{ model.transmission_type.name }}
          <span v-if="model.type">, {{ model.type.name }}</span>
        </span>
      </div>
    </div>
    <div>
      <div class="car__specs__details">
        <VehicleSpecsList :model="model" />
      </div>
    </div>
  </li>
</template>

<script>
import { ACCESSORY_TAG } from "@/models/Accessory";
import VehicleImage from "./VehicleImage";
import VehicleSpecsList from "./VehicleSpecsList";

export default {
  name: "vehicle-item",
  props: ["model"],
  components: {
    VehicleImage,
    VehicleSpecsList
  },
  data() {
    return {
      ACCESSORY_TAG: ACCESSORY_TAG
    };
  },
  filters: {
    distance: value => {
      return value ? parseFloat(value + "").toFixed(1) + " km" : value;
    },
    slice: (value, start, end) => {
      return value ? value.substring(start, end) : value;
    },
    lowercase: val => val.toLowerCase()
  },
  methods: {
    onBookClick() {
      this.$emit("book", this.model);
    }
  }
};
</script>

<style scoped>
li {
  list-style-type: none;
}
</style>
